import { tagCreator } from './utils';

export const LIST = 'LIST';

export const types = {
  ME: 'ME',
  PAYMENT_METHODS: 'PAYMENT_METHODS', // LIST
  PURCHASE_ORDERS: 'PURCHASE_ORDERS', // LIST
  PRODUCT: 'PRODUCT',
  FAVORITE_PRODUCTS: 'FAVORITE_PRODUCTS', // LIST
  PRODUCT_REVIEWS: 'PRODUCT_REVIEWS',
  PRODUCT_CITATIONS: 'PRODUCT_CITATIONS',
  PRODUCT_AVAILABLE_SUPPLIERS: 'PRODUCT_AVAILABLE_SUPPLIERS', // product_id
  PRODUCT_ACCESSORIES: 'PRODUCT_ACCESSORIES', // product_id
  PRODUCT_RELATED_ITEMS: 'PRODUCT_RELATED_ITEMS', // product_id
  PRODUCT_QUESTIONS: 'PRODUCT_QUESTIONS',
  PRODUCT_FAMILY: 'PRDOCUT_FAMILY',
  REVIEW_COMMENTS: 'REVIEW_COMMENTS',
  SEARCH_PRODUCTS: 'SEARCH_PRODUCTS',
  CUSTOMER_ADDRESS: 'CUSTOMER_ADDRESS',
  CUSTOMER_BOOKMARKS: 'CUSTOMER_BOOKMARKS', // LIST
  CUSTOMER_CART: 'CUSTOMER_CART', // LIST, cart_id
  CART_PREVIEW: 'CART_PREVIEW', // cart_id
  CART_SUMMARY: 'CART_SUMMARY',
  ORDER: 'ORDER', // LIST, order_id
  ORDER_PLACED: 'ORDER_PLACED', // order_id
  ORDER_SHIPMENT_STATUS: 'ORDER_SHIPMENT_STATUS', // order_id
  ORDER_CALCULATOR: 'ORDER_CALCULATOR', // order_id
  LAB_GROUPS: 'LAB_GROUPS', // LIST
  LAB_GROUP_MEMBERS_SEARCH: 'LAB_GROUP_MEMBERS_SEARCH', // LIST
  LAB_GROUP_MEMBERS: 'LAB_GROUP_MEMBERS', // group_id
  LAB_GROUP_SETTINGS: 'LAB_GROUP_SETTINGS', // group_id
  QUOTES: 'QUOTES', // LIST
  CATEGORIES_FLAT_TREE: 'CATEGORIES_FLAT_TREE', // LIST
  CATEGORIES_TREE: 'CATEGORIES_TREE', // LIST
  COUNTRIES: 'COUNTRIES', // LIST
  SUPPLIERS: 'SUPPLIERS',
  SUPPLIER_PARTNERS: 'SUPPLIER_PARTNERS', // LIST
  SETUP_FORM: 'SETUP_FORM', // form_id
  STRAPI_HELP_CENTER_CATEGORIES: 'STRAPI_HELP_CENTER_CATEGORIES',
  STRAPI_HELP_CENTER_ARTICLE: 'STRAPI_HELP_CENTER_ARTICLE',
  STRAPI_CAREER_ARTICLE: 'STRAPI_CAREER_ARTICLE',
  STRAPI_BLOG_ARTICLE: 'STRAPI_BLOG_ARTICLE',
  RECENTLY_VIEWED: 'RECENTLY_VIEWED', // LIST
  BLOCKS: 'BLOCKS', // LIST
  NEWS: 'NEWS', // LIST
  NEWS_CATEGORIES: 'NEWS_CATEGORIES', // LIST
  BLOG: 'BLOG', // LIST,
  BLOG_CATEGORIES: 'BLOG_CATEGORIES', // LIST
  BLOG_ARTICLE: 'BLOG_ARTICLE',
  CAREERS: 'CAREERS', //LIST
  CAREERS_CATEGORIES: 'CAREERS_CATEGORIES', //LIST
  CAREERS_VACANCY: 'CAREERS_ARTICLE',
  HELP_CENTER_CATEGORIES: 'HELP_CENTER_CATEGORIES',
  HELP_CENTER_ARTICLES: 'HELP_CENTER_ARTICLES',
  GRANTS: 'GRANTS',
  SUPPORT_TICKETS: 'SUPPORT_TICKETS',
  REQUEST_TICKETS: 'REQUEST_TICKETS',
  DOCUMENTS: 'DOCUMENTS',
};

export const tags = Object.entries(types).reduce(
  (res, [name, value]) => ({
    ...res,
    [name]: tagCreator(value),
  }),
  {},
);
